import React from "react";

import OoPopover from "../../../components/UI/Popover/OoPopover";

/**
 * One Account Settings row: leading icon + label + help popover on the left,
 * caller-supplied control on the right. The row shape is written once here.
 */
const AccountSettingRow = ({
  icon,
  label,
  popoverTarget,
  popoverHeader,
  popoverBody,
  popoverPlacement,
  className,
  children,
}) => {
  let rowClassName = "bwai-as-row";
  if (className) {
    rowClassName = `bwai-as-row ${className}`;
  }

  let placement = "left";
  if (popoverPlacement) {
    placement = popoverPlacement;
  }

  const hasPopover =
    popoverTarget !== undefined && popoverTarget !== null && popoverTarget !== "";

  return (
    <div className={rowClassName}>
      <div className="bwai-as-row-label">
        <span className="bwai-as-row-icon">{icon}</span>
        <span className="bwai-as-row-label-text">{label}</span>
        {hasPopover && (
          <OoPopover
            target={popoverTarget}
            placement={placement}
            headerText={popoverHeader}
            bodyText={popoverBody}
          />
        )}
      </div>
      <div className="bwai-as-row-control">{children}</div>
    </div>
  );
};

export default AccountSettingRow;
